/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Node_HealthInputs */

const en_service_node_health = /** @type {(inputs: Service_Node_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Node health`)
};

const ar_service_node_health = /** @type {(inputs: Service_Node_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سلامة العقدة`)
};

const bn_service_node_health = /** @type {(inputs: Service_Node_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নোড হেলথ`)
};

const de_service_node_health = /** @type {(inputs: Service_Node_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knotenzustand`)
};

const es_service_node_health = /** @type {(inputs: Service_Node_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado del nodo`)
};

const fr_service_node_health = /** @type {(inputs: Service_Node_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Santé du nœud`)
};

const pt_service_node_health = /** @type {(inputs: Service_Node_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integridade do nó`)
};

const zh_service_node_health = /** @type {(inputs: Service_Node_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`节点健康状况`)
};

const tr_service_node_health = /** @type {(inputs: Service_Node_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Düğüm sağlığı`)
};

const ru_service_node_health = /** @type {(inputs: Service_Node_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Состояние узла`)
};

const pl_service_node_health = /** @type {(inputs: Service_Node_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stan węzła`)
};

/**
* | output |
* | --- |
* | "Node health" |
*
* @param {Service_Node_HealthInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_node_health = /** @type {((inputs?: Service_Node_HealthInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Node_HealthInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_service_node_health(inputs)
	if (locale === "bn") return bn_service_node_health(inputs)
	if (locale === "de") return de_service_node_health(inputs)
	if (locale === "es") return es_service_node_health(inputs)
	if (locale === "fr") return fr_service_node_health(inputs)
	if (locale === "pt") return pt_service_node_health(inputs)
	if (locale === "zh") return zh_service_node_health(inputs)
	if (locale === "tr") return tr_service_node_health(inputs)
	if (locale === "ru") return ru_service_node_health(inputs)
	if (locale === "pl") return pl_service_node_health(inputs)
	return en_service_node_health(inputs)
});